import api from './api';

// 1. 앱 설명 챗봇 질문
export const askHelpBot = async (question, chatHistory = []) => {
    try {
        const response = await api.post('/api/help/chat', {
            question,
            chatHistory
        });
        return response.data; // Expected: { answer: "..." } or similar
    } catch (error) {
        console.error('Help Bot API Error:', error);
        throw error;
    }
};
